import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerEdit, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import { LabelForm, LabelCabecera } from '../componentes_generales/componentes_formulario/labels/';
import global_axios  from '../../funciones_globales/interaccionapi';
import {  cargarCatalogosGenericoAsync } from '../../funciones_globales/catalogos';
import moment from 'moment';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { formatearFecha } from '../../funciones_globales/format';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { formatearLabel } from '../../funciones_globales/format';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import { formatearFechaMoment_a_String } from '../../funciones_globales/format';
import { cargarCatalogosGenericoAsyncInvertido } from '../../funciones_globales/catalogos';

class FormImpor15 extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            //Estados formulario
            operacion: 'M', //G & M
            permiso: 'G',
            ult_transaccion: null,
            num_diario: null,
            esconsolidado:null,
            numconsolidado:null,

            //FECHAS
            fechaCompra: null,
            fechaEmbarque: null,
            fechaAduana: null,
            fechaArribo: null,
            valorfob:0,

            //Input
            compra: '',
            importacion_sel: null,
            transitoLoaded: null,
            ident_prov: null,

            mails: null,
            error: 0
        };
       

        //Properties
        this.actualizarCampos = this.actualizarCampos.bind(this);
        this.getImportacionById = this.getImportacionById.bind(this);

        //ACTIONS

        this.limpiarPantalla = this.limpiarPantalla.bind(this);
        this.getconsolidado= this.getconsolidado.bind(this);
        this.actualizarImportacion= this.actualizarImportacion.bind(this);
        
    }   
    
    //Change over controls
    actualizarCampos(event){
        const target = event.target;       
        const name = target.name;    
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({
            [name]: value
        });
    }

    //FUNCTION AGREGADA PROVEEDOR
    getOptions_Proveedores(input, callback){
        if (input.toString().length >= 2 ){
            let cadena_busq = '&cadena_busq=' + input;
            cargarCatalogosGenericoAsync('/proveedores?tipo=catalogo', cadena_busq, callback)
        }
    }

    getOptions_Importaciones(input, callback){
        if (input.toString().length >= 3 ){
            let cadena_busq = '?cadena_busq=' + input;
            cargarCatalogosGenericoAsyncInvertido('/importaciones', cadena_busq, callback)  
        }
    }

    getImportacionById(){

        if(this.state.importacion_sel===null){
            alert("Digite un movimiento");
        }else{

            //this.getconsolidado()
            console.log('Ingresa Funcion')
            global_axios({
                method: 'GET',
                //url: '/compras?importacion='+this.state.importacion_sel.value.toString()+'&status=P&status=E'
                url:  '/importaciones/' + this.state.importacion_sel.value.toString()+'/importacionencabezadoFechas'
            })
            .then((response)=> {
              
                    var respuesta = response.data.ImportacionResponse;
                    this.setState({valorfob: respuesta.ValorFOB});
                    
                    if(respuesta.FechaSalida!==null){
                        var fechaSalida = formatearFecha(respuesta.FechaSalida.toString().substring(0,10))
                        
                        this.setState({fechaEmbarque: moment(fechaSalida,'DD/MM/YYYY')})
                    }
                    if(respuesta.FechaLLegada!==null){
                        var fechaLlegada = formatearFecha(respuesta.FechaLLegada.toString().substring(0,10))
                        
                        this.setState({fechaAduana: moment(fechaLlegada,'DD/MM/YYYY')})
                    }

                    if(respuesta.FechaRecepcion!==null){
                        var fechaRecepcion = formatearFecha(respuesta.FechaRecepcion.toString().substring(0,10))
                        
                        this.setState({fechaArribo: moment(fechaRecepcion,'DD/MM/YYYY')})
                    }

            })
            .catch((error)=>{                
                alert(error.response?error.response.data.msg:error.message);      
            });
        }
    }

    //Operaciones
    cargarObjetos(ruta){
        return new Promise((resolve, reject) => {
            global_axios.get(ruta)
            .then((response)=>{
                resolve(response.data)
            })
            .catch((err)=>{

                reject('Compra no existe o esta anulada...');
            });
        });
    }

    //CICLO REACT

    componentDidMount(){
        Promise.all([
            this.cargarObjetos('/catalogos?tipo=otros&opcion=IMP-LCOMP'),
            this.props.generar_LogAuditoriaIngresoForm('0306')
         ])
        .then(([res_mail]) => {
            

            if(res_mail===null){
                alert("No es posible cargar los destinatarios, no se puede continuar")
            }else{
                this.setState({mails: formatearLabel(res_mail[0].Descripcion), error:1})
            }
            
        });        
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0306');
    }
    
    //FUNCION BOTONES

    actualizarImportacion(){
        var errors = "";
        var proceder = true;
        var data = {};
      

        
        
        if(this.state.importacion_sel===null){
            proceder = false;
            errors=errors+"- Digite una Importacion.\n";
        }

        if(this.state.fechaEmbarque===null){
            proceder = false;
            errors=errors+"- Digite una fecha de Embarque.\n";
        }

        if(this.state.fechaAduana===null){
            proceder = false;
            errors=errors+"- Digite un fecha de Aduana.\n";
        }

        if(this.state.fechaArribo===null){
            proceder = false;
            errors=errors+"- Digite un fecha de Recepcion.\n";
        }

       

        if(proceder === true ){
            var mensaje;
            mensaje = window.confirm("¿Esta seguro que quiere Actualizar la importacion #"+this.state.importacion_sel.value+"?"); 
            if (mensaje){
                data.Usuario= this.props.usuario;
                data.importacion= this.state.importacion_sel.value
                data.FechaEmbarque = formatearFechaMoment_a_String(this.state.fechaEmbarque);
                data.FechaAduana = formatearFechaMoment_a_String(this.state.fechaAduana);
                data.FechaArribo = formatearFechaMoment_a_String(this.state.fechaArribo);


                let config_request = {
                    method: 'PATCH',
                    url: '/importaciones/'+this.state.importacion_sel.value.toString()+'/importacionActualizaEncabezado',
                    data
                }
                
                global_axios(config_request)
                .then((response)=> {             
                    alert(response.data.msg);
                })
                .catch((error)=>{                  
                    alert(error.response?error.response.data.msg:error.message);                
                });
            }

        }else{
            alert(errors);
        }
       
    }

    
getconsolidado(){

        let config_request = {
            method: 'GET',
            url: '/compras/'+this.state.importacion_sel.value+'/importacionConsolidado/',
        }
        global_axios(config_request)
        .then((response)=> {             
            var respuesta = response.data[0];

            this.setState({esconsolidado: respuesta.Consolidado});
            
        
        })
        .catch((error)=>{                  
            alert(error.response?error.response.data.msg:error.message);                
        });
}


    clear(){
        this.setState({compra:'', ident_prov: null, fechaCompra: null, transitoLoaded: null , esconsolidado:null, numconsolidado:null, error: 0
        ,fechaEmbarque:null, fechaAduana:null, fechaArribo:null, valorfob:0,importacion_sel: null
    })
    }

    limpiarPantalla(param){
        this.clear();
    }

    render(){
        return(
            <ContenedorForm porc_ancho={80}>
             <HeaderForm>
                <TituloForm>Actualizar Fechas Importacion </TituloForm>
                <LabelCabecera>Ult. trans.: {this.state.ult_transaccion}</LabelCabecera>
                {/* <LabelCabecera>N°. diario: {this.state.num_diario}</LabelCabecera> */}
            </HeaderForm>
                <CuerpoForm>
                    <ContainerEdit>
                        <Row>
                            <ContainerCol className='col-md-4'>        
                                <LabelForm>Importación:</LabelForm>            
                                <div className='input-group'>
                                <ReactSelectAsync value={this.state.importacion_sel} func_loadOptions={this.getOptions_Importaciones} func_onChange={(value)=>{this.setState({importacion_sel: value!==null?value:null})}}/>
                                    <span className='input-group-addon addon-busq-especif'><button type="button" className='btn btn-default medida-button-busq-especif' onClick={this.getImportacionById}><i className="fa fa-pencil-square-o"></i> Buscar</button></span>
                                </div>
                            </ContainerCol>               
                        </Row>
                    </ContainerEdit>
                    <Row>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Valor FOB</LabelForm>
                            <InputText name="fob" mayusculas={true} disabled={true} value={this.state.valorfob} onChange={this.actualizarCampos} maxLength='100'/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Fecha Embarque:</LabelForm>
                            <PickerFecha fechaSeleccionada={this.state.fechaEmbarque} 
                            func_onChange={(fechaEscogida)=>{this.setState({fechaEmbarque: fechaEscogida})}}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Fecha Aduana:</LabelForm>
                            <PickerFecha fechaSeleccionada={this.state.fechaAduana}  
                            func_onChange={(fechaEscogida)=>{this.setState({fechaAduana: fechaEscogida})}}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Fecha Recepcion Oficina:</LabelForm>
                            <PickerFecha fechaSeleccionada={this.state.fechaArribo} 
                            func_onChange={(fechaEscogida)=>{this.setState({fechaArribo: fechaEscogida})}}/>
                        </ContainerCol>
                        
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-12'>
                            <br/>
                            <div className='btn-group pull-right'>
                                <button type='button' className='btn btn-primary btn-sm'  onClick={this.actualizarImportacion}><i className='fa fa-floppy-o fa-lg'/> Actualizar Importacion</button>
                                <button type='button' className='btn btn-sm' onClick={()=>{this.limpiarPantalla('A')}}><i className='fa fa-trash-o fa-lg'/> Limpiar</button>
                                <button type='button' className='btn btn-danger btn-sm' disabled={this.state.transitoLoaded==='N'?false:true} onClick={this.reversarCompra}><i className='fa fa-window-close  fa-lg'/> Reversar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}


const mapStateToProps = ((state) => {
    return {puntoFacturacionSel: state.ventas.ptoFacturacionSel, 
            permiso: state.sesion.valoresSesionForm.Permiso,
            usuario: state.sesion.valoresSesionForm.Usuario,
            IdRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
            permiteCambioFProceso: state.sesion.valoresSesionForm.CambioFechaProceso,
            diasPermiteCambioFProceso: state.sesion.valoresSesionForm.CantidadDias,}
  });
  
  const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm}, dispatch)
  });
  
  export default connect (mapStateToProps, mapDispatchToProps)(FormImpor15);